export const PromoBanner = () => {
  return <div style={{
    width: '100%',
    background: '#ff651a',
    color: '#fff',
    textAlign: 'center',
    fontSize: 16,
    lineHeight: '40px',
    padding: '8px 12px',
    boxSizing: 'border-box',
    zIndex: 1400
  }}>
    <span>Black Friday and Winter Sale: Up to 50% Off</span>
  </div>
}